/**
 * reservierung.js
 */

let moment = require('moment');

import $ from "jquery";

import {} from '@chenfengyuan/datepicker'

import '@chenfengyuan/datepicker/dist/datepicker.css';

initializeDatepicker();

setTimeField();

initializeFormSubmit();

initializeCalendarImageHover();

initializeNextPrev();

function calculateStartDate() {
    let min_days   = 2;
    let lockDown   = moment('2023-12-31');
    let start_test = moment().add(min_days, 'days');
    return moment.min(lockDown, start_test).format("MM/DD/YYYY");
}

function initializeDatepicker() {
    let start_date = calculateStartDate();

    $('[data-toggle="datepicker"]').datepicker({
        language: 'de-DE',
        format: 'mm/dd/yyyy',
        trigger: '#cal',
        autoHide: true,
        daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    });

    /* Wenn Datum ausgewählt wurde, dann den Text in der Datumsbox anpassen */
    $('[data-toggle="datepicker"]').on('pick.datepicker', function (e) {
        setDisplayDate();
    });

    $('[data-toggle="datepicker"]').datepicker('setDate', start_date);
    $('[data-toggle="datepicker"]').datepicker('setStartDate', start_date);
}

function setDisplayDate() {
    let d = getDateObjectFromPicker();
    $('#dd').html(d.locale('de').format('dd') + ', ' + d.format('DD.MM.YYYY'));
}

function setTimeField() {
// Initialize Time
    let dt = new Date();
    let hour = dt.getHours() + 1;
    if (hour > 18) {
        hour = 18;
    }
    if (hour < 9) {
        hour = 9;
    }
    if (hour < 10) {
        hour = '0' + hour;
    }
    $("#uhrzeit").val(hour + ":00");
}

function initializeFormSubmit() {
    $('#reservation_form').on('submit', function (e) {
        let cName = checkName();
        let cTelefon = checkTelefon();
        let cEmail = checkEmail();
        let cTime = checkTime();

        if (cName && cTelefon && cEmail && cTime) {
            $('.error_global').addClass('hidden');
        } else {
            $('.error_global').removeClass('hidden');
            e.preventDefault();
        }
    });
}

function initializeCalendarImageHover() {
    /* Mouseover für Kalendersymbol */
    $(".image-container").mouseover(function () {
        $(this).attr('src', $(this).data("hover"));
    }).mouseout(function () {
        $(this).attr('src', $(this).data("src"));
    });

}

function getDateObjectFromPicker() {
    let date = $('[data-toggle="datepicker"]').datepicker('getDate');
    return moment(date);
}

function initializeNextPrev() {
    $('#next_day').on('click', function (e) {
        let date = $('[data-toggle="datepicker"]').datepicker('getDate');
        // let d = Date.parse(date).addDays(1).toString("dd.MM.yyyy");

        let d = moment(date, 'MM/DD/YYY').add(1, 'days').format("MM/DD/YYYY");
        $('[data-toggle="datepicker"]').datepicker('setDate', d);
    });

    $('#prev_day').on('click', function (e) {
        let date = $('[data-toggle="datepicker"]').datepicker('getDate');

        if (moment(date).format('MM/DD/YYYY') === calculateStartDate()) {
            return;
        }

        let d = moment(date, 'MM/DD/YYYY').add(-1, 'days').format("MM/DD/YYYY");

        $('[data-toggle="datepicker"]').datepicker('setDate', d);
    });
}

function checkName() {
    let errName = $('.error_name');
    let errorName = $('.name-input');
    let name = $('#name').val();
    if (!name.trim()) {
        errName.removeClass('hidden');
        errorName.removeClass('long-input');
        return false;
    }

    errName.addClass('hidden');
    errorName.addClass('long-input');
    return true;
}

function checkTelefon() {
    let errTel = $('.error_telefon');
    let errorTelefon = $('.telefon-input');
    let telefon = $('#telefon').val();
    if (!telefon.trim()) {
        errTel.removeClass('hidden');
        errorTelefon.removeClass('long-input');
        return false;
    }

    errTel.addClass('hidden');
    errorTelefon.addClass('long-input');
    return true;
}

function checkEmail() {
    let errEmail = $('.error_email');
    let errorEmail = $('.email-input');
    let email = $('#email').val();

    if (email.search('@') === -1) {
        errEmail.removeClass('hidden');
        errorEmail.removeClass('long-input');
        return false;
    }

    if (email.search(/\./) === -1) {
        errEmail.removeClass('hidden');
        errorEmail.removeClass('long-input');
        return false;
    }

    errEmail.addClass('hidden');
    errorEmail.addClass('long-input');
    return true;
}

function checkTime() {
    let d = getDateObjectFromPicker();

    let is_sunday   = d.day() === 0;
    let is_saturday = d.day() === 6;
    let is_feiertag = feiertage.indexOf(d) !== -1;

    let uhrzeit = $("#uhrzeit").val();

    let errtime = $('.error_time');

    if (
        (is_sunday || is_feiertag) &&
        (uhrzeit > '13:00' || uhrzeit < '09:00')
    ) {
        $('#et2').addClass('hidden');
        $('#et1').removeClass('hidden');
        errtime.removeClass('hidden');
        return false;
    }

    if (is_saturday && uhrzeit < '09:00') {
        $('#et1').addClass('hidden');
        $('#et2').removeClass('hidden');
        errtime.removeClass('hidden');
        return false;
    }

    errtime.addClass('hidden');
    return true;
}

let feiertage = [
    "01.01.2021",
    "08.03.2021",
    "02.04.2021",
    "04.04.2021",
    "05.04.2021",
    "01.05.2021",
    "13.05.2021",
    "23.05.2021",
    "24.05.2021",
    "03.10.2021",
    "24.12.2021",
    "25.12.2021",
    "26.12.2021",
    "31.12.2021",

    "01.01.2022",
    "08.03.2022",
    "15.04.2022",
    "17.04.2022",
    "18.04.2022",
    "01.05.2022",
    "26.05.2022",
    "05.06.2022",
    "06.06.2022",
    "03.10.2022",
    "24.12.2022",
    "25.12.2022",
    "26.12.2022",
    "31.12.2022",

    "01.01.2023",
    "08.03.2023",
    "07.04.2023",
    "09.04.2023",
    "10.04.2023",
    "01.05.2023",
    "18.05.2023",
    "28.05.2023",
    "29.05.2023",
    "03.10.2023",
    "24.12.2023",
    "25.12.2023",
    "26.12.2023",
    "31.12.2023",
];

//Reservation button position

    $(window).scroll(function() {    
       // var scroll = $(window).scrollTop();
    
        if($(window).scrollTop() + $(window).height() > $(document).height() - 110) {
           $(".reservieren-container").addClass("move-up");
        } else {
           $(".reservieren-container").removeClass("move-up");
        }
   });

    /////
    //function reveal() {
    //    var reveals = document.querySelectorAll(".move-up");
    //  
   //     for (var i = 0; i < reveals.length; i++) {
    //      var windowHeight = window.innerHeight;
   //       var elementTop = reveals[i].getBoundingClientRect().top;
    //      var elementVisible = 30;
      
    //      if (elementTop < windowHeight - elementVisible) {
    //        reveals[i].classList.add("move-animate");
    //      } else {
    //        reveals[i].classList.remove("move-animate");
     //     }
   //     }
    //  }
      
  //    window.addEventListener("scroll", reveal);

